import styles from './TrialPage.module.css';
import { useContext, useEffect, useState } from 'react';
import { dataContext } from '../../App';
import giftBox  from './giftBox.png'
import { fetchSubscriptionUrlByEventId } from '../../services';
import { Spinner } from 'react-bootstrap';
import gsap from 'gsap';
import activityLogSubmission from '../../helper/activitylog';

const TrialPage = () => {
  const {playerData,token} = useContext(dataContext);
  const [isLoading, setIsLoading] = useState(false);
  const rightAnswer = parseInt(sessionStorage.getItem('quizPlay_totalRightScore')) || 0;
  let isPassed = true;

  const eventId = sessionStorage.getItem('trial_eventId');
  useEffect(() => {
    sessionStorage.removeItem('played_eventId');
    sessionStorage.removeItem('trial_eventId');
  }, [])

  useEffect(() => {
    if (isPassed) {
      gsap.timeline({ delay: 1 })
        .fromTo(`.${styles.fireworks}`, {
        y: '-100%',
        scale: .6,
        duration: 2,
        ease: 'power1.inOut',
        display: 'none'
      }, {
        y: '0%',
        scale: 1.1,
        duration: 2,
        ease: 'power1.inOut',
        display: 'block'
      })
      .to(`.${styles.fireworks}`, {
        opacity: 0,
        duration: .5,
        ease: 'power1.inOut',
        display: 'none'
      });
    }
    const headerStyle = isPassed ? {
      background: 'radial-gradient(112.5% 111.22% at 104.39% 0%, #a788fd 0%, #250878 100%)'
    } : {
      background: 'linear-gradient(161.15deg, #757575 12.73%, #050505 72.95%)'
    };

    gsap.set(`.${styles.header}`, headerStyle);
  }, [isPassed]);


  function handleSubscribeButtonClick() {
    setIsLoading(true);
    fetchSubscriptionUrlByEventId(token, eventId).then(res => {
      activityLogSubmission('trial_page_subsBtn_clicked', playerData?.msisdn);
      window.location.replace(`${res?.redirectURL}`);
      setIsLoading(false);
    });
  }
  return (
    <div className={styles.container}>
      <div className={styles.giftBox}>
      <div className={styles.header}>
        <img src={require('./fireworks.png')} className={styles.fireworks} alt="result-page-header" />
        <img src={require('./trophy.png')} className={styles.trophy} alt="result-page-header" />
        <div>
          <div className={styles.congratsTitle}>অভিনন্দন</div>
          <div className={styles.congratsText}>আপনি কুইজটি সম্পূর্ণভাবে শেষ করেছেন।</div>
        </div>
        <div className={styles.score}>আপনার স্কোর: {rightAnswer}</div>
      </div>


        
        {/* <div className={styles.giftIcon}>
          <img src={giftBox} alt="Gift Box" className={styles.giftImage} />
        </div>
        <h1 className={styles.title}>সাবস্ক্রাইব করে চালিয়ে যান</h1> */}
        <p className={styles.subtitle}>
        ফুল এক্সেস পেতে, র‍্যাঙ্কিংস দেখতে এবং প্রাইজ জিততে এখনই সাবস্ক্রাইব করুন
        </p>
        <button 
          className={styles.button}
          onClick={handleSubscribeButtonClick}
        >
          {isLoading ? <Spinner animation="border" variant="light" size="sm" /> : "প্রাইজ জিততে এখনই সাবস্ক্রাইব করুন"}
        </button>
      </div>
    </div>
  );
}

export default TrialPage;